module.exports = __webpack_public_path__ + "24999d9d1b658c05a6ff1807105d7d9d.svg";